export default __webpack_public_path__ + "static/media/passport.a8740e72.png";